import { render, staticRenderFns } from "./TagsList.vue?vue&type=template&id=3c873585&"
import script from "./TagsList.vue?vue&type=script&lang=js&"
export * from "./TagsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QToolbar,QToolbarTitle,QSpace,QBtn,QItem,QItemSection,QItemLabel,QChip,QInnerLoading,QSpinner} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QToolbar,QToolbarTitle,QSpace,QBtn,QItem,QItemSection,QItemLabel,QChip,QInnerLoading,QSpinner})
